import { ValidationProps } from 'ui';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { CodeItemCodesAccess } from '../item/types';
import { CodeFieldIncludeInactiveKey } from '../types-store';
import { CodeListItem, CodeListModifiedComments, CodeListModifiedFactor } from './types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const ACTION = {
  REQUEST_CODE_ITEMS: 'INDICATOR_FACTORS_LIST:REQUEST_CODE_ITEMS',
  RECEIVE_CODE_ITEMS: 'INDICATOR_FACTORS_LIST:RECEIVE_CODE_ITEMS',
  FAIL_CODE_ITEMS: 'INDICATOR_FACTORS_LIST:FAIL_CODE_ITEMS',

  REQUEST_CODETABLE_ADMINISTRATION_LIST: 'INDICATOR_FACTORS_LIST:REQUEST_CODETABLE_ADMINISTRATION_LIST',
  RECEIVE_CODETABLE_ADMINISTRATION_LIST: 'INDICATOR_FACTORS_LIST:RECEIVE_CODETABLE_ADMINISTRATION_LIST',
  FAIL_CODETABLE_ADMINISTRATION_LIST: 'INDICATOR_FACTORS_LIST:FAIL_CODETABLE_ADMINISTRATION_LIST',

  REQUEST_CODE_ITEM_DELETE: 'INDICATOR_FACTORS_LIST:REQUEST_CODE_ITEM_DELETE',
  RECEIVE_CODE_ITEM_DELETE: 'INDICATOR_FACTORS_LIST:RECEIVE_CODE_ITEM_DELETE',
  FAIL_CODE_ITEM_DELETE: 'INDICATOR_FACTORS_LIST:FAIL_CODE_ITEM_DELETE',

  UPDATE_QUERY: 'INDICATOR_FACTORS_LIST:UPDATE_QUERY',
  UPDATE_INCLUDE_INACTIVE: 'INDICATOR_FACTORS_LIST:UPDATE_INCLUDE_INACTIVE',

  UPDATE_SEARCH_MODEL: 'INDICATOR_FACTORS_LIST:UPDATE_SEARCH_MODEL',
  RESET_LIST_STATE: 'INDICATOR_FACTORS_LIST:RESET_LIST_STATE',

  DUPLICATE_ROWS_FIELDS_BY_KEY: 'INDICATOR_FACTORS_LIST:UPDATE_BY_KEY',
  RESET_VALIDATION: 'INDICATOR_FACTORS_LIST:RESET_VALIDATION',
  UPDATE_IS_DIRTY: 'INDICATOR_FACTORS_LIST:UPDATE_IS_DIRTY',
  REQUEST_DUPLICATE_ROWS: 'INDICATOR_FACTORS_LIST:REQUEST_DUPLICATE_ROWS',
  RECEIVE_DUPLICATE_ROWS: 'INDICATOR_FACTORS_LIST:RECEIVE_DUPLICATE_ROWS',
  FAIL_DUPLICATE_ROWS: 'INDICATOR_FACTORS_LIST:FAIL_DUPLICATE_ROWS',
  REQUEST_DELETE_ROWS: 'INDICATOR_FACTORS_LIST:REQUEST_DELETE_ROWS',
  RECEIVE_DELETE_ROWS: 'INDICATOR_FACTORS_LIST:RECEIVE_DELETE_ROWS',
  FAIL_DELETE_ROWS: 'INDICATOR_FACTORS_LIST:FAIL_DELETE_ROWS',
  UPDATE_DUPLICATE_ROWS_VALIDATION: 'INDICATOR_FACTORS_LIST:UPDATE_DUPLICATE_ROWS_VALIDATION',

  REQUEST_LOAD_CODE_PARAMETERS: 'INDICATOR_FACTORS_LIST:REQUEST_LOAD_CODE_PARAMETERS',
  RECEIVE_LOAD_CODE_PARAMETERS: 'INDICATOR_FACTORS_LIST:RECEIVE_LOAD_CODE_PARAMETERS',
  FAIL_LOAD_CODE_PARAMETERS: 'INDICATOR_FACTORS_LIST:FAIL_LOAD_CODE_PARAMETERS',

  CLEAR_DUPLICATE_ROWS: 'INDICATOR_FACTORS_LIST:CLEAR_DUPLICATE_ROWS',

  MODIFY_FACTOR: 'INDICATOR_FACTORS_LIST:MODIFY_FACTOR',
  MODIFY_COMMENTS: 'INDICATOR_FACTORS_LIST:MODIFY_COMMENTS',
  CANCEL_CHANGES: 'INDICATOR_FACTORS_LIST:CANCEL_CHANGES',

  REQUEST_SAVE_FACTORS: 'INDICATOR_FACTORS_LIST:REQUEST_SAVE_FACTORS',
  RECEIVE_SAVE_FACTORS: 'INDICATOR_FACTORS_LIST:RECEIVE_SAVE_FACTORS',
  FAIL_SAVE_FACTORS: 'INDICATOR_FACTORS_LIST:FAIL_SAVE_FACTORS',

  REQUEST_SAVE_COMMENTS: 'INDICATOR_FACTORS_LIST:REQUEST_SAVE_COMMENTS',
  RECEIVE_SAVE_COMMENTS: 'INDICATOR_FACTORS_LIST:RECEIVE_SAVE_COMMENTS',
  FAIL_SAVE_COMMENTS: 'INDICATOR_FACTORS_LIST:FAIL_SAVE_COMMENTS'
};

export class RequestCodeItems {
  public type: string = ACTION.REQUEST_CODE_ITEMS;
  constructor(public codetableId: number, public requestId: number, public model: FilterSearchModel, public clearResults: boolean) {
  }
}

export class ReceiveCodeItems {
  public type: string = ACTION.RECEIVE_CODE_ITEMS;
  constructor(
    public codetableId: number,
    public requestId: number,
    public list: CodeListItem[],
    public numberOfResults: number,
    public itemAccesses: CodeItemCodesAccess[]) { }
}

export class FailCodeItems {
  public type: string = ACTION.FAIL_CODE_ITEMS;
  constructor(public codetableId: number, public requestId: number) {
  }
}

export class RequestCodetableAdministrationList {
  public type: string = ACTION.REQUEST_CODETABLE_ADMINISTRATION_LIST;
}

export class ReceiveCodetableAdministrationList {
  public type: string = ACTION.RECEIVE_CODETABLE_ADMINISTRATION_LIST;
  constructor(public options: CodeComplexValue<number>[]) {
  }
}

export class FailCodetableAdministrationList {
  public type: string = ACTION.FAIL_CODETABLE_ADMINISTRATION_LIST;
}

export class RequestCodeItemDelete {
  public type: string = ACTION.REQUEST_CODE_ITEM_DELETE;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ReceiveCodeItemDelete {
  public type: string = ACTION.RECEIVE_CODE_ITEM_DELETE;
  constructor(public codeId: number) {
  }
}

export class FailCodeItemDelete {
  public type: string = ACTION.FAIL_CODE_ITEM_DELETE;
  constructor(public codeId: number) {
  }
}

export class UpdateQuery {
  public type: string = ACTION.UPDATE_QUERY;
  constructor(public value: string) {
  }
}

export class UpdateIncludeInactive {
  public type: string = ACTION.UPDATE_INCLUDE_INACTIVE;
  constructor(public value: CodeFieldIncludeInactiveKey) {
  }
}

export class UpdateSearchModel {
  public type: string = ACTION.UPDATE_SEARCH_MODEL;
  constructor(public model: FilterSearchModel) {
  }
}

export class ResetListState {
  public type: string = ACTION.RESET_LIST_STATE;
}

export class DuplicateRowsFieldsByKey {
  public type: string = ACTION.DUPLICATE_ROWS_FIELDS_BY_KEY;
  constructor(public key: string, public value: any) {
  }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public key: string) {
  }
}

export class UpdateIsDirty {
  public type: string = ACTION.UPDATE_IS_DIRTY;
  constructor(public isDirty: boolean) {
  }
}

export class RequestDuplicateRows {
  public type: string = ACTION.REQUEST_DUPLICATE_ROWS;
}

export class ReceiveDuplicateRows {
  public type: string = ACTION.RECEIVE_DUPLICATE_ROWS;
}

export class FailDuplicateRows {
  public type: string = ACTION.FAIL_DUPLICATE_ROWS;
}

export class RequestDeleteRows {
  public type: string = ACTION.REQUEST_DELETE_ROWS;
}

export class ReceiveDeleteRows {
  public type: string = ACTION.RECEIVE_DELETE_ROWS;
}

export class FailDeleteRows {
  public type: string = ACTION.FAIL_DELETE_ROWS;
}

export class UpdateDuplicateRowsValidation {
  public type: string = ACTION.UPDATE_DUPLICATE_ROWS_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class RequestLoadCodeParameters {
  public type: string = ACTION.REQUEST_LOAD_CODE_PARAMETERS;
}

export class ReceiveLoadCodeParameters {
  public type: string = ACTION.RECEIVE_LOAD_CODE_PARAMETERS;
  constructor(public parameters: CodeListItem[]) { }
}

export class FailLoadCodeParameters {
  public type: string = ACTION.FAIL_LOAD_CODE_PARAMETERS;
}

export class ClearDuplicateRows {
  public type: string = ACTION.CLEAR_DUPLICATE_ROWS;
}

export class ModifyFactor {
  public type: string = ACTION.MODIFY_FACTOR;
  constructor(public modifiedData: CodeListModifiedFactor) { }
}

export class ModifyComments {
  public type: string = ACTION.MODIFY_COMMENTS;
  constructor(public modifiedData: CodeListModifiedComments) { }
}

export class CancelChanges {
  public type: string = ACTION.CANCEL_CHANGES;
}

export class RequestSaveFactors {
  public type: string = ACTION.REQUEST_SAVE_FACTORS;
}

export class ReceiveSaveFactors {
  public type: string = ACTION.RECEIVE_SAVE_FACTORS;
}

export class FailSaveFactors {
  public type: string = ACTION.FAIL_SAVE_FACTORS;
  constructor(public validation: { [propertyName: string]: ValidationProps }) { }
}

export class RequestSaveComments {
  public type: string = ACTION.REQUEST_SAVE_COMMENTS;
}

export class ReceiveSaveComments {
  public type: string = ACTION.RECEIVE_SAVE_COMMENTS;
}

export class FailSaveComments {
  public type: string = ACTION.FAIL_SAVE_COMMENTS;
  constructor(public validation: { [propertyName: string]: ValidationProps }) { }
}
